import { EditOutlined, LinkOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Empty, Input, Space, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";

type PublicListUrlPanelProps = {
  orgId: string | null;
  url: string | null;
  isLoading?: boolean;
  isSaving?: boolean;
  onSave: (url: string) => Promise<boolean>;
};

export const PublicListUrlPanel = ({
  orgId,
  url,
  isLoading = false,
  isSaving = false,
  onSave,
}: PublicListUrlPanelProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftUrl, setDraftUrl] = useState(url ?? "");

  useEffect(() => {
    setIsEditing(false);
    setDraftUrl(url ?? "");
  }, [orgId, url]);

  const handleEdit = () => {
    setDraftUrl(url ?? "");
    setIsEditing(true);
  };

  const handleSave = async () => {
    const didSave = await onSave(draftUrl);
    if (didSave) {
      setIsEditing(false);
    }
  };

  return (
    <div
      style={{
        border: "1px solid #D2D2D2",
        background: "#fff",
        borderRadius: "8px 8px 0 0",
        overflow: "hidden",
        minHeight: 280,
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          backgroundColor: "#184461",
          color: "#fff",
        }}
      >
        <Typography.Text style={{ color: "#fff", fontSize: 16 }}>Public List URL</Typography.Text>
      </div>

      <div style={{ padding: 24 }}>
        <Spin spinning={isLoading}>
          {!orgId ? (
            <div
              style={{
                minHeight: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Empty description="Select an organization" />
            </div>
          ) : (
            <div>
              <Typography.Text
                type="secondary"
                style={{ display: "block", marginBottom: 8, fontSize: 12, letterSpacing: 0.4 }}
              >
                MARKETING PUBLIC LIST URL
              </Typography.Text>
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  value={draftUrl}
                  readOnly={!isEditing}
                  disabled={isSaving}
                  onChange={(event) => setDraftUrl(event.target.value)}
                  onPressEnter={() => {
                    if (isEditing && !isSaving) {
                      void handleSave();
                    }
                  }}
                  placeholder="https://example.com/listings"
                  prefix={<LinkOutlined style={{ color: "#184461" }} />}
                  style={{ background: isEditing ? "#fff" : "#F7F9FC" }}
                />
                {isEditing ? (
                  <Button type="primary" icon={<SaveOutlined />} loading={isSaving} onClick={() => void handleSave()}>
                    Save
                  </Button>
                ) : (
                  <Button icon={<EditOutlined />} onClick={handleEdit}>
                    Edit
                  </Button>
                )}
              </Space.Compact>
              <Typography.Text type="secondary" style={{ display: "block", marginTop: 12, fontSize: 12 }}>
                This URL is used for the organization&apos;s public marketing listings.
              </Typography.Text>
            </div>
          )}
        </Spin>
      </div>
    </div>
  );
};
